import { Message } from '@iwoca/orion';
import sharedStyles from '../RegistrationForm.module.css';

type TProps = {
  errorMessage?: string;
};

// TODO: use built in error from orion when we upgrade and remove any custom error styling https://iwoca.atlassian.net/browse/BAE-2951
export const FieldError = ({ errorMessage }: TProps) => {
  if (!errorMessage) {
    return null;
  }

  return (
    <Message
      className={sharedStyles.errorMessage}
      message={errorMessage}
      type="error"
    />
  );
};
